module.exports = __webpack_public_path__ + "static/media/download-square-svgrepo-com.0abe84c3.svg";